import { ButtonSizeEnum, ButtonTypeEnum } from "@/components/atoms/Button";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import { VISIT_HELP_CENTRE_en } from "../data/common.data";
import { VISIT_HELP_CENTRE_kr } from "../data/common.data.kr";

export const NUM_OF_CREATORS = "200,000+";
export const NUM_OF_CREATORS_US = "200,000+";

export const getEmojiFromUnicode = ({
  emojiUnicode,
}: {
  emojiUnicode: string;
}) => {
  let selectedIconUnicode;

  try {
    selectedIconUnicode = String.fromCodePoint(parseInt(emojiUnicode, 16));
    return selectedIconUnicode;
  } catch (err) {
    selectedIconUnicode = "";
    console.error("ERROR in parsing emoji unicode:", emojiUnicode, err);
    return "";
  }
};

export const FAQ_HREF = "https://us.help.graphy.com/";
// TODO: Localize this:
export const DEFAULT_COUNTRY_CODE = "IN";
export const DEFAULT_CURRENCY_SYMBOL = "₹";
export const HAS_ACCEPTED_COOKIES = "has_accepted_cookies" as const;

export const COMPANY_LEGAL_NAME = "Graphy Labs Private Limited";
export const COMPANY_LEGAL_NAME_US = "Graphy Inc.";

export const CtaVisitHelpCentre_en = {
  type: ButtonTypeEnum.Secondary,
  size: ButtonSizeEnum.Regular,
  text: VISIT_HELP_CENTRE_en,
  href: FAQ_HREF,
  target: "_blank",
  amplitudeEvent: {
    eventName: LANDING_PAGE_EVENTS.VISIT_HELP_CENTER_TAPPED.LABEL,
    eventProperties: {
      source: "faqs",
    },
  },
};

export const CtaVisitHelpCentre_kr = {
  type: ButtonTypeEnum.Secondary,
  size: ButtonSizeEnum.Regular,
  text: VISIT_HELP_CENTRE_kr,
  href: FAQ_HREF,
  target: "_blank",
  amplitudeEvent: {
    eventName: LANDING_PAGE_EVENTS.VISIT_HELP_CENTER_TAPPED.LABEL,
    eventProperties: {
      source: "faqs",
    },
  },
};

export const PAGES  = {
  AFFILIATE_PAGE: 'affiliate',
  MEMBERSHIP_PAGE: 'memberships'
}
